import { Map } from 'immutable'
import { Action } from '@ngrx/store'
import * as templatesTypes from './templates.types'
import { Template } from './templates.interface'

export class FetchTemplatesRequest implements Action {
  readonly type = templatesTypes.FETCH_TEMPLATES_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchTemplatesSuccess implements Action {
  readonly type = templatesTypes.FETCH_TEMPLATES_SUCCESS
  constructor(
    public payload: Template[],
    public total: number,
    public results: number,
  ) {}
}

export class FetchTemplatesFailure implements Action {
  readonly type = templatesTypes.FETCH_TEMPLATES_FAILURE
  constructor(public payload: any) {}
}

export class FetchTemplateTagsRequest implements Action {
  readonly type = templatesTypes.FETCH_TEMPLATE_TAGS_REQUEST
  constructor(public payload: any = {}) {}
}

export class FetchTemplateTagsSuccess implements Action {
  readonly type = templatesTypes.FETCH_TEMPLATE_TAGS_SUCCESS
  constructor(public payload: any) {}
}

export class FetchTemplateTagsFailure implements Action {
  readonly type = templatesTypes.FETCH_TEMPLATE_TAGS_FAILURE
  constructor(public payload: any) {}
}

export class FetchTemplateRequest implements Action {
  readonly type = templatesTypes.FETCH_TEMPLATE_REQUEST
  constructor(public id: number) {}
}

export class FetchTemplateSuccess implements Action {
  readonly type = templatesTypes.FETCH_TEMPLATE_SUCCESS
  constructor(public payload: Template) {}
}

export class FetchTemplateFailure implements Action {
  readonly type = templatesTypes.FETCH_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

export class DeleteTemplateRequest implements Action {
  readonly type = templatesTypes.DELETE_TEMPLATE_REQUEST
  constructor(public id: number) {}
}

export class DeleteTemplateSuccess implements Action {
  readonly type = templatesTypes.DELETE_TEMPLATE_SUCCESS
  constructor() {}
}

export class DeleteTemplateFailure implements Action {
  readonly type = templatesTypes.DELETE_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

export class CreateTemplateRequest implements Action {
  readonly type = templatesTypes.CREATE_TEMPLATE_REQUEST
  constructor(public payload) {}
}

export class CreateTemplateSuccess implements Action {
  readonly type = templatesTypes.CREATE_TEMPLATE_SUCCESS
  constructor() {}
}

export class CreateTemplateFailure implements Action {
  readonly type = templatesTypes.CREATE_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

export class UpdateTemplateRequest implements Action {
  readonly type = templatesTypes.UPDATE_TEMPLATE_REQUEST
  constructor(public id: number, public payload) {}
}

export class UpdateTemplateSuccess implements Action {
  readonly type = templatesTypes.UPDATE_TEMPLATE_SUCCESS
  constructor() {}
}

export class UpdateTemplateFailure implements Action {
  readonly type = templatesTypes.UPDATE_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

export class DownloadTemplateRequest implements Action {
  readonly type = templatesTypes.DOWNLOAD_TEMPLATE_REQUEST
  constructor(public document: Map<string, any>) {}
}

export class DownloadTemplateSuccess implements Action {
  readonly type = templatesTypes.DOWNLOAD_TEMPLATE_SUCCESS
  constructor(public payload: any, public document: Map<string, any>) {}
}

export class DownloadTemplateFailure implements Action {
  readonly type = templatesTypes.DOWNLOAD_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

export class FetchTestTemplateRequest implements Action {
  readonly type = templatesTypes.FETCH_TEST_TEMPLATE_REQUEST
  constructor(public file: File, public params: any) {}
}

export class FetchTestTemplateSuccess implements Action {
  readonly type = templatesTypes.FETCH_TEST_TEMPLATE_SUCCESS
  constructor(public payload: any) {}
}

export class FetchTestTemplateFailure implements Action {
  readonly type = templatesTypes.FETCH_TEST_TEMPLATE_FAILURE
  constructor(public payload: any) {}
}

// Common

export class UpdateField implements Action {
  readonly type = templatesTypes.UPDATE_FIELD
  public constructor(
    public field: string,
    public value: any,
    public path: string,
  ) {}
}

export class SetDefaultData implements Action {
  readonly type = templatesTypes.SET_DEFAULT_DATA
  public constructor(public path: string) {}
}

export type Actions =
  | UpdateTemplateRequest
  | UpdateTemplateSuccess
  | UpdateTemplateFailure
  | FetchTemplatesSuccess
  | FetchTemplatesFailure
  | FetchTemplatesRequest
  | FetchTemplateSuccess
  | FetchTemplateFailure
  | FetchTemplateRequest
  | CreateTemplateRequest
  | CreateTemplateSuccess
  | CreateTemplateFailure
  | DeleteTemplateRequest
  | DeleteTemplateSuccess
  | DeleteTemplateFailure
  | SetDefaultData
  | UpdateField
  | FetchTemplatesRequest
  | FetchTemplatesSuccess
  | FetchTemplatesFailure
  | DownloadTemplateRequest
  | DownloadTemplateSuccess
  | DownloadTemplateFailure
  | FetchTemplateTagsRequest
  | FetchTemplateTagsSuccess
  | FetchTemplateTagsFailure
  | FetchTestTemplateRequest
  | FetchTestTemplateSuccess
  | FetchTestTemplateFailure
